//main.tsx — avatar.xrscape.ai: the character mirror at /, its admin at /admin

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import AvatarAdmin from '../src/avatar/AvatarAdmin'
import AvatarMirror from '../src/avatar/AvatarMirror'
import { keepAwake } from '../src/kiosk/wakeLock'
import '../src/styles.css'

//Same as try-on: a kiosk tab stays open for days, so poll for a new build hourly.
registerSW({
	immediate: true,
	onRegisteredSW(_url, registration) {
		if (registration) setInterval(() => void registration.update(), 60 * 60 * 1000)
	},
})

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root')

const isAdmin = window.location.pathname === '/admin'

createRoot(container).render(<StrictMode>{isAdmin ? <AvatarAdmin /> : <AvatarMirror />}</StrictMode>)

if (!isAdmin) keepAwake()
